import { render, staticRenderFns } from "./BaseSearchIcon.vue?vue&type=template&id=67240ab3"
import script from "./BaseSearchIcon.vue?vue&type=script&lang=js"
export * from "./BaseSearchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports